module.exports = __webpack_public_path__ + "static/img/8.1d1c0de.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/1/zh/8.png
// module id = T7am
// module chunks = 0